import React from "react";
import ContentCard from "../contentCard/ContentCard";
import stylesPc from "./ContentList.module.css";
import stylesSp from "./ContentList_SP.module.css";
import { IsDevice } from "../../../../components/function/useDeviceFlag";

interface ContentListProps {
    contents: any[];
    setMsg: (msg: string) => void;
}

export default function ContentList({ contents, setMsg }: ContentListProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    return (
        <div className={styles.list}>
            {contents.map((content) => (
                <ContentCard
                    key={content.fileType ? "slidestock_" + content.id : "video_" + content.id}
                    content={content}
                    setMsg={setMsg}
                />
            ))}
        </div>
    );
}
